<div class="tabs">
  @for ( category of categories; track category) {
    <div class="tab" [id]="category.id" [class.active]="category.id == activeTab" (click)="onClickTab(category)">
      @if(category.isTranslate) {
        {{ category.name | translate}}
      } @else {
        {{ category.name }}}
    </div>
  }
</div>